import React from "react";
import { DefaultButton, Modal, Label, Stack } from "@fluentui/react";
import { InfoModalProps } from "@/screen/Identities/Interfaces/IdentitiesMainScreenInterfaces";
import { contentStyles, styleLabel, styleDefButton, SavingsPlanTable } from "@/screen/Identities/Styles/IdentitiesMainScreenStyles";

const ModalSavingsPlans: React.FC<InfoModalProps> = ({isOpen, identity, identityFullName, onClose}) =>
{
    return(
        <Modal isOpen={isOpen}>
            <div className={contentStyles.header}>
                <Label styles={styleLabel}>
                    Planes de Ahorro del interviniente <br />
                    <strong>{identityFullName}</strong>
                </Label>
            </div>
            <div className={contentStyles.body}>
                {identity && identity.savingsPlans.length > 0 ?
                (
                    <SavingsPlanTable>
                        <thead>
                            <tr>
                                <th>Nombre del Plan</th>
                                <th>Nº Contrato</th>
                                <th>Estado</th>
                                <th>Rol en el Contrato</th>
                            </tr>
                        </thead>
                        <tbody>
                            {identity.savingsPlans.map((plan) =>
                            (
                                <tr key={plan.id}>
                                    <td>{plan.name}</td>
                                    <td>{plan.contractNumber}</td>
                                    <td>{plan.status}</td>
                                    <td>{plan.roleInContract}</td>
                                </tr>
                            ))}
                        </tbody>
                    </SavingsPlanTable>
                ) :
                (
                    <p>Este interviniente no tiene planes de ahorro asociados.</p>
                )}
            </div>
            <Stack.Item style={{display: "flex", justifyContent: "center", padding: "10px"}}>
                <DefaultButton styles={styleDefButton} onClick={onClose}>
                    Cerrar
                </DefaultButton>
            </Stack.Item>
        </Modal>
    );
};

export default ModalSavingsPlans;